import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import './segmentsMenuContent.scss';
var SegmentsMenuItem = function SegmentsMenuItem(_ref) {
  var title = _ref.title,
    url = _ref.url;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: url
  }, title));
};
var SegmentsMenuSection = function SegmentsMenuSection(_ref2) {
  var section = _ref2.section;
  return /*#__PURE__*/React.createElement("div", {
    className: "segments-menu-section"
  }, /*#__PURE__*/React.createElement("h4", null, section.url ? /*#__PURE__*/React.createElement("a", {
    href: section.url
  }, section.title) : section.title), section.items.length > 0 && /*#__PURE__*/React.createElement("ul", null, section.items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(SegmentsMenuItem, {
      key: index,
      title: item.title,
      url: item.url
    });
  })));
};
var SegmentsMenuColumn = function SegmentsMenuColumn(_ref3) {
  var segment = _ref3.segment;
  return /*#__PURE__*/React.createElement("div", {
    className: "segments-menu-column"
  }, segment.title ? /*#__PURE__*/React.createElement("h3", null, segment.title) : /*#__PURE__*/React.createElement("h3", {
    "aria-label": "Continued list"
  }, "\xA0"), /*#__PURE__*/React.createElement("div", {
    className: "segments-menu-sections"
  }, segment.items.map(function (section, index) {
    return /*#__PURE__*/React.createElement(SegmentsMenuSection, {
      key: index,
      section: section
    });
  })));
};

// Allow segments with a lot of items to be split into two columns
var chunkSegments = function chunkSegments(segments, chunkSize) {
  return segments.flatMap(function (segment) {
    if (segment.items.length <= chunkSize) {
      return [segment];
    }
    return [_objectSpread(_objectSpread({}, segment), {}, {
      items: segment.items.slice(0, chunkSize)
    }), _objectSpread(_objectSpread({}, segment), {}, {
      title: '',
      items: segment.items.slice(chunkSize)
    })];
  });
};
export var SegmentsMenuContent = function SegmentsMenuContent(_ref4) {
  var segments = _ref4.segments,
    maxColumnLength = _ref4.maxColumnLength;
  var chunked = maxColumnLength ? chunkSegments(segments.segments, maxColumnLength) : segments.segments;
  return /*#__PURE__*/React.createElement("div", {
    className: "segments-menu"
  }, chunked.map(function (segment, index) {
    return /*#__PURE__*/React.createElement(SegmentsMenuColumn, {
      key: index,
      segment: segment
    });
  }));
};